<template>
    <div class="content flex-sub wrapper flex flex-direction">
        <div class="flex-sub padding-lr">
           <div class="bg-gray">
               <ck-decoupled-editor ref="editor" :title="ruleForm.title" :content="ruleForm.content"></ck-decoupled-editor>
           </div>
            <div class="flex align-center justify-end margin-top">
<!--                <el-button :loading="loading" class="btn min" type="primary" @click="submitForm('ruleForm',1)" v-if="status === 2">保存-->
<!--                </el-button>-->
                <el-button :loading="loading" class="btn min" type="primary" @click="submitForm('ruleForm',2)">发布
                </el-button>
            </div>
        </div>
        <el-button class="choose-model bg-white text-red" round @click="templateDialog = true"><i class="el-icon-s-operation"></i>推荐模版</el-button>
        <template-dialog :dialog-visible="templateDialog" :type="0" @watchState="watchState"></template-dialog>
    </div>
</template>

<script>

import {TOAST, toast} from "@/utils/utils";
import {addMeetingWorkable, getMeetingDetail} from "@/api";
import CkDecoupledEditor from "@/views/web/components/CKDecoupledEditor";
import TemplateDialog from "@/views/web/manager/page/standard/components/TemplateDialog";

export default {
    name: "MeetingWorkable",
    components: {TemplateDialog, CkDecoupledEditor},
    data() {
        return {
            ruleForm: {
                title: '',
                content: ''
            },
            loading: false,
            readonly:true,
            status:1,
            templateDialog: false,
        }
    },
    props: {
        type: {//1党员大会 2 委员会
            type: Number,
            default: 1
        },
        aid: {
            type: Number,
            default: 0
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        if (this.aid) this.init()
    },
    methods: {
        async init() {
            let _data = await getMeetingDetail(this.aid)
            this.ruleForm.title = _data.data.meeting_title
            this.ruleForm.content = _data.data.meeting_content
            this.status = _data.data.status

        },
        submitForm(formName,is_storage) {
            this.addItem(is_storage);
        },
        async addItem(is_storage) {
            let _info = this.$refs.editor.getInfo()
            if (!_info.content) return  toast('请输入内容', TOAST.error)
            this.ruleForm.title = _info.title
            this.ruleForm.content = _info.content
            this.loading = true
            let _data = await addMeetingWorkable(this.aid,this.ruleForm.title,this.ruleForm.content,is_storage)
            this.loading = false
            if (_data.status === 200) {
                toast('发布成功', TOAST.success)
                this.$emit('watchNext', this.aid,false)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        watchState(data) {
            if (data) {
                this.ruleForm.title = data.title
                this.ruleForm.content = data.content
            }
            this.templateDialog = false;
        }
    },
    filters: {

    },
    watch: {
        aid() {
            if (this.aid) {
                this.init();
            } else {
                this.ruleForm.title = ''
                this.ruleForm.content = ''
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.content {
    position: relative;
    .choose-model {
        position: absolute;
        bottom: 200px;
        right: 30px;
    }
}
</style>